import useSWR from 'swr';

import { usePrivate } from '@/components/private/PrivateContext';
import { enqueueSnackbar } from '@/providers/SnackbarProvider';

import { useGetAnimalSpeciesMessages } from './messages';

export interface useGetAnimalSpeciesOptions {
  shouldFetch?: boolean;
}

export function useGetAnimalSpecies(options?: useGetAnimalSpeciesOptions) {
  const mergedOptions: useGetAnimalSpeciesOptions = {
    shouldFetch: true,
    ...options,
  };

  // const { animalSpeciesApi } = usePrivate();

  // const results = useSWR(
  //   animalSpeciesApi && mergedOptions.shouldFetch ? '/api/AnimalSpecies' : null,
  //   () => animalSpeciesApi?.apiAnimalSpeciesGet(),
  //   {
  //     onError: (error) => {
  //       enqueueSnackbar(
  //         useGetAnimalSpeciesMessages[
  //           'useGetAnimalSpecies.fetch.unexpectedError'
  //         ],
  //         {
  //           variant: 'error',
  //         },
  //       );
  //       console.error(
  //         '[BREEDLOGIC] <useGetAnimalSpecies> error fetching animal species.',
  //         error,
  //       );
  //     },
  //   },
  // );

  // const isLoadingOrValidating =
  //   results.isLoading || results.isValidating || !animalSpeciesApi;

  const isLoadingOrValidating = false;
  const results = {} as any;

  return { ...results, isLoadingOrValidating };
}
